(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CustomEvents"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.event-card__form').forEach(function (form) {
    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error((data && data.description) || 'Could not add to cart');
              });
            }
            return response.json();
          })
          .then(function () {
            window.location.href = window.Shopify && Shopify.routes && Shopify.routes.root
              ? Shopify.routes.root + 'checkout'
              : '/checkout';
          })
          .catch(function (error) {
            if (submitButton) submitButton.disabled = false;
            window.alert(error.message || 'Something went wrong adding this to your cart.');
          });
      },
      true
    );
  });

  document.querySelectorAll('.event-card__form-wrap--team').forEach(function (wrap) {
    var dataEl = wrap.querySelector('.event-team-data');
    if (!dataEl) return;

    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      variants = [];
    }
    if (!variants.length) return;

    var priceEl = wrap.querySelector('[data-price]');
    var priceSubEl = wrap.querySelector('[data-price-sub]');
    var countEl = wrap.querySelector('[data-count]');
    var variantInput = wrap.querySelector('[data-variant-input]');
    var submitButton = wrap.querySelector('[data-submit-button]');
    var labelEl = submitButton ? submitButton.querySelector('[data-button-label]') : null;
    var decreaseBtn = wrap.querySelector('[data-decrease]');
    var increaseBtn = wrap.querySelector('[data-increase]');

    var defaultVariantId = wrap.dataset.defaultVariant;
    var index = 0;
    variants.forEach(function (variant, i) {
      if (String(variant.variantId) === String(defaultVariantId)) {
        index = i;
      }
    });

    function render() {
      var variant = variants[index];
      if (countEl) countEl.textContent = variant.count;
      if (priceEl) priceEl.textContent = variant.price;
      if (priceSubEl) {
        priceSubEl.textContent = variant.count + ' Players × ' + variant.unitPrice + '/Player';
      }
      if (variantInput) variantInput.value = variant.variantId;
      if (decreaseBtn) decreaseBtn.disabled = index === 0;
      if (increaseBtn) increaseBtn.disabled = index === variants.length - 1;
      if (submitButton) {
        submitButton.disabled = !variant.available;
      }
      if (labelEl) {
        labelEl.textContent = variant.available
          ? labelEl.dataset.label || labelEl.textContent
          : 'Sold Out';
      }
    }

    if (labelEl && !labelEl.dataset.label) {
      labelEl.dataset.label = labelEl.textContent.trim();
    }

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        if (index > 0) {
          index -= 1;
          render();
        }
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', function () {
        if (index < variants.length - 1) {
          index += 1;
          render();
        }
      });
    }

    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["KunaFCKits"] && !Shopify.designMode) return;
  try {
    
(function () {
  var pieces = document.querySelectorAll('.kit-piece');
  if (!pieces.length) return;

  var canHover = window.matchMedia('(hover: hover)').matches;
  if (canHover) return;

  pieces.forEach(function (piece) {
    piece.addEventListener('click', function (event) {
      var isActive = piece.classList.contains('is-active');
      pieces.forEach(function (el) {
        el.classList.remove('is-active');
      });
      if (!isActive) {
        event.preventDefault();
        piece.classList.add('is-active');
      }
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.kit-piece')) {
      pieces.forEach(function (el) {
        el.classList.remove('is-active');
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minigame"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KICK_MS = 300;
  var LAUNCH_DELAY_MS = 120;
  var FLIGHT_MS = 1700;

  document.querySelectorAll('.goal-game__row').forEach(function (row) {
    var leftPlayer = row.querySelector('.goal-game__player--left');
    var rightPlayer = row.querySelector('.goal-game__player--right');
    var ball = row.querySelector('.goal-game__ball');
    if (!leftPlayer || !rightPlayer || !ball) return;

    var side = 'left';
    var busy = false;

    function updateActive() {
      leftPlayer.classList.toggle('has-ball', side === 'left');
      rightPlayer.classList.toggle('has-ball', side === 'right');
    }

    function kick(from) {
      if (busy || side !== from) return;
      busy = true;

      var player = from === 'left' ? leftPlayer : rightPlayer;
      var to = from === 'left' ? 'right' : 'left';

      player.classList.add('is-kicking');

      setTimeout(function () {
        ball.classList.remove('is-flying-left', 'is-flying-right');
        void ball.offsetWidth;
        ball.classList.add(to === 'right' ? 'is-flying-right' : 'is-flying-left');
      }, LAUNCH_DELAY_MS);

      setTimeout(function () {
        player.classList.remove('is-kicking');
      }, KICK_MS);

      setTimeout(function () {
        side = to;
        updateActive();
        busy = false;
      }, LAUNCH_DELAY_MS + FLIGHT_MS + 60);
    }

    leftPlayer.addEventListener('click', function () {
      kick('left');
    });
    rightPlayer.addEventListener('click', function () {
      kick('right');
    });

    updateActive();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
